import { logVersionMetadata } from './versionMetadata.js';

export { logVersionMetadata };
